// START-CodeLeap [17-Aug-2026]: [1.0-R-UX offline navigation screen]
import { useEffect, useState } from 'react';

export const useOnlineStatus = (): boolean => {
  // Default to true when navigator is undefined (e.g. server-side rendering).
  const [isOnline, setIsOnline] = useState<boolean>(() =>
    typeof navigator !== 'undefined' ? navigator.onLine : true
  );

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return isOnline;
};
// /END-CodeLeap [17-Aug-2026]: [1.0-R-UX offline navigation screen]
